<template>
    <div id="quiz">
        <iframe class="typeform-widget" data-hj-allow-iframe=""
             src="https://spiritt.io/apply-to-spiritt/eGhp9wrR?s=spmail"></iframe>
    </div>
</template>

<script>


    export default {
        name: 'sxsw',

      data() {
        return {
          uaParam: '',
          ipParam: '',
          fbpParam: '',
          fbcParam: '',
          iframeUrl: "eGhp9wrR?s=spmail", //https://spiritt.io/apply-to-spiritt/eGhp9wrR?s=spmail
          utm: {
            utm_source: null,
            utm_medium: null,
            utm_campaign: null,
            utm_term: null,
            utm_content: null,
            fbclid: null,
          }
        }
      },
      computed: {

      },

      mounted () {


      },
    }
</script>
<style lang="css" scoped>
    #quiz {
        background: linear-gradient(to right top, rgb(80, 116, 169), rgb(112, 91, 177), rgb(129, 90, 179), rgb(109, 63, 161), rgb(129, 90, 179), rgb(146, 61, 169), rgb(119, 43, 167), rgb(119, 43, 167), rgb(121, 42, 163), rgb(119, 41, 165), rgb(118, 41, 163), rgb(120, 41, 166));
    }
    .typeform-widget {
        position: fixed;
        border: none;
        top: 0; right: 0;
        bottom: 0; left: 0;
        width: 100%;
        height: 100%;
    }
    .for-tests{
      position: absolute;
      top: 40px;
      left: 40px;
      background-color: #fff;
      border-radius: 20px;
      z-index: 20000000;
      padding: 20px;
      box-shadow: 0 0 30px #00c092;
    }
</style>
